import React from 'react';
import './PackTreeView.css';

/**
 * PackTreeView -- indented tree visualisation of a ChainPack.
 *
 * One row per chain, with each predicate listed beneath. Used by the
 * Pack Management page (expanded row) and reusable from the Process
 * Builder properties panel when a chain_reasoner node picks a registry.
 *
 * @param {Object} props
 * @param {Object} props.pack - Pack summary returned by GET /api/admin/packs.
 */
function PackTreeView({ pack }) {
  if (!pack) return null;
  const chains = Array.isArray(pack.chains) ? pack.chains : [];
  return (
    <div className="pack-tree-view">
      {pack.description && (
        <p className="pack-tree-desc">{pack.description}</p>
      )}
      {chains.length === 0 ? (
        <p className="pack-tree-empty">— pack has no chains —</p>
      ) : (
        <ul className="pack-tree-chains">
          {chains.map((chain, ci) => {
            const iterate = chain.iterate_over;
            const iterateLabel = iterate
              ? typeof iterate === 'string'
                ? iterate
                : (iterate.binding_kind || iterate.kind || JSON.stringify(iterate))
              : null;
            return (
              <li key={chain.chain_id || ci} className="pack-tree-chain">
                <div className="pack-tree-chain-header">
                  <code className="pack-tree-chain-id">{chain.chain_id || `chain_${ci}`}</code>
                  {chain.chain_name && (
                    <span className="pack-tree-chain-name">{chain.chain_name}</span>
                  )}
                  {iterateLabel && (
                    <span className="pack-tree-iterate">iterate_over: <code>{iterateLabel}</code></span>
                  )}
                </div>
                <ul className="pack-tree-predicates">
                  {(chain.predicates || []).map((pred, pi) => (
                    <li key={pi} className={`pack-tree-pred kind-${pred.kind}`}>
                      <span className="pack-tree-pred-kind">{pred.kind}</span>
                      {pred.anchor && <span className="pack-tree-anchor">{pred.anchor}</span>}
                      <span className="pack-tree-detail">
                        {pred.kind === 'rule' && (
                          <>
                            <code>{pred.case_query || '…'}</code>
                            {pred.graph_ref && <span className="pack-tree-graph-ref"> @ {pred.graph_ref}</span>}
                          </>
                        )}
                        {pred.kind === 'case_field' && (
                          <>
                            <code>{pred.case_path || '?'}</code>
                            {pred.op && <span> {pred.op}</span>}
                          </>
                        )}
                        {pred.kind === 'case_nl' && (
                          <code>{pred.case_query || '…'}</code>
                        )}
                      </span>
                    </li>
                  ))}
                </ul>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default PackTreeView;
